<template>
  <div class="content" v-loading="loading">
    <el-button type="primary" @click="loopContorl('all',1)" round>全开</el-button>
    <el-button type="info"  @click="loopContorl('all',0)" round>全关</el-button>
    <el-table :data="tableData" style="width: 100%;margin-top:0;">
      <el-table-column prop="loop_id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="loop_name" label="网关名称"> </el-table-column>
      <el-table-column
        label="状态"
        prop="ste"
        width="140"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="type">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.ste"
            :active-value="1"
            :inactive-value="0"
            active-color="#3ba631"
            inactive-color="#B9B9B9"
            @change="loopContorl(scope.row.loop_id,$event)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList"
export default {
  name: "loopControl",
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      steType: ["关", "开"],
      steColorType: ["valuered", "valuegreen"],
      tableData: []
    };
  },
  methods: {
    getTableData() {
      this.loading = true;
      lightListApi.getLoopList(this.id).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          this.tableData = res.data.data;
          console.log('tableData',this.tableData)
        }
      });
    },
    loopContorl(loop_id, value) { //回路控制
      let params = {}
      if(loop_id=='all'){
        params = {
          type: 1,
          on: value,
          loop_id: 'all'
        }
      }else{
        params = {
          type: 0,
          on: value,
          loop_id: loop_id
        }
      }
      lightListApi.lampLoopControl(this.id,params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
